import { render, staticRenderFns } from "./Fonts.vue?vue&type=template&id=346c735a&"
import script from "./Fonts.vue?vue&type=script&lang=js&"
export * from "./Fonts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports